import { format } from 'date-fns';
import { MousePointerClick } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LinkClickDto } from '@/Domain/api/Conversation/dto/LinkClick.dto';
import { LinkClickHelper } from '@/Domain/helper/LinkClick.helper';

type Props = {
  linkClick: LinkClickDto;
  timestamp: string;
  minimal?: boolean; // Optional prop for even more minimal display
};

export const LinkClickItem = ({ linkClick, timestamp, minimal = false }: Props) => {
  const { t } = useTranslation(['inbox']);
  const { original_url, message_ord } = linkClick;

  const formatTimestamp = (timestamp: string): string => format(new Date(timestamp), 'h:mm a');

  // Ultra minimal version - just a tiny indicator
  if (minimal) {
    return (
      <li className="flex items-center gap-1 text-xs text-foreground-subtle mx-4 py-0.5">
        <MousePointerClick className="h-2 w-2" />
        <span>{t('link_clicked_minimal')}</span>
      </li>
    );
  }

  return (
    <li className="border-l-2 border-border py-2 px-3 mx-4 text-xs">
      <div className="flex items-center gap-2 mb-1">
        <MousePointerClick className="h-3 w-3 text-foreground-subtle" />
        <span className="text-muted-foreground font-medium">{t('link_clicked')}</span>
        <span className="text-foreground-subtle text-xs">{t('from_message', { message_ord })}</span>
      </div>

      <div className="flex items-center gap-2 mb-1">
        <a
          href={original_url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 hover:underline truncate flex-1 font-medium"
          title={original_url}
        >
          {LinkClickHelper.getDomainAndPathFromUrl(original_url)}
        </a>
      </div>
      <div className="flex flex-col items-start gap-1 text-foreground-subtle">
        <span>{formatTimestamp(timestamp)}</span>
      </div>
    </li>
  );
};
